import React from 'react';

export default function About() {
  return (
    <div className="about-container">
      <section className="about-section">
        <h2>About Pro BioGen AI</h2>
        <p>
          In today's digital world, your professional bio is your first impression. 
          Whether it's for LinkedIn, a company website, or a speaking engagement, 
          writing about yourself is notoriously difficult. <strong>Pro BioGen AI</strong> was 
          developed to bridge the gap between your skills and a compelling narrative.
        </p>

        <h3>Our Mission</h3>
        <p>
          Our mission is to empower professionals by providing instant, high-quality 
          templates that highlight their unique strengths. We believe that everyone 
          has a story worth telling, and technology should make it easier to tell it.
        </p>

        <div className="features-grid">
          <div className="feature-item">
            <h4><span role="img" aria-label="speed">🚀</span> Speed</h4>
            <p>Go from a blank page to a finished bio in under 30 seconds.</p>
          </div>
          <div className="feature-item">
            <h4><span role="img" aria-label="precision">🎯</span> Precision</h4>
            <p>Our templates focus on industry keywords that recruiters actually look for.</p>
          </div>
          <div className="feature-item">
            <h4><span role="img" aria-label="variety">✨</span> Variety</h4>
            <p>Choose from professional, creative, or casual tones to match your personal brand.</p>
          </div>
        </div>

        <h3>Frequently Asked Questions</h3>
        <div className="faq-item">
          <strong>Is this tool free to use?</strong>
          <p>Yes! Pro BioGen AI is a free resource supported by non-intrusive advertisements.</p>
        </div>
        <div className="faq-item">
          <strong>Do you store my data?</strong>
          <p>No. The information you type in is used only to generate your bio in real-time. We do not store your personal details on our servers.</p>
        </div>
        <div className="faq-item">
          <strong>Can I customize the generated bio?</strong>
          <p>Absolutely! After generating a bio, you can edit it to better fit your style and preferences.</p>
        </div>
      </section>
    </div>
  );
}

